import angular from 'angular';
import moment from 'moment';
import {
    IArquivoTrabalhadorUploadForm,
    IArquivoTrabalhadorUploadSubmitData,
} from './arquivos.trabalhador.upload.modal.model';
import {
    fileToBase64,
    formatBytes,
    getLimitDate,
    limparInputArquivo,
    montarMeses,
    montarSelectCompetencias,
    TAMANHO_MAXIMO_ARQUIVO,
    validarArquivo,
} from '@utils/upload-arquivo';

export class MeurhArquivosTrabalhadorUploadModalController {
    static $inject = ['$uibModalInstance', '$rootScope', '$scope', 'entity', 'NewToaster'];

    public form: angular.IFormController;
    public busy = false;
    public isFileValid = false;
    public selectCompetencias = this.setSelects();
    public readonly nomeMaxLength = 100;
    public readonly tamanhoMaximoArquivo = TAMANHO_MAXIMO_ARQUIVO;
    public readonly tamanhoMaximoArquivoLabel = formatBytes(TAMANHO_MAXIMO_ARQUIVO, 0);

    constructor(
        public $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
        public $rootScope: angular.IRootScopeService & { configuracoes: { [key: string]: unknown } },
        public $scope: angular.IScope,
        public entity: IArquivoTrabalhadorUploadForm,
        public NewToaster: { pop: Function },
    ) {}

    public onFileChange() {
        this.isFileValid = this.validateSelectedFile();
        this.$scope.$applyAsync();
    }

    public submit() {
        this.validateNomeField();

        if (!this.validateSelectedFile()) {
            this.isFileValid = false;
            this.$scope.$applyAsync();
            return;
        }

        if (!this.isFileValid || this.form.$invalid || this.busy) {
            return;
        }

        const nome = this.normalizeNome();
        if (nome.length > this.nomeMaxLength) {
            return;
        }

        const file = this.entity.file?.[0];
        if (!file) {
            return;
        }

        this.busy = true;

        this.fileToBase64(file)
            .then((conteudo) => {
                const payload: IArquivoTrabalhadorUploadSubmitData = {
                    nome,
                    conteudo,
                    competenciaano: this.normalizeInteger(this.entity.competenciaano),
                    competenciames: this.normalizeInteger(this.entity.competenciames),
                };

                this.$uibModalInstance.close(payload);
            })
            .catch(() => {
                this.NewToaster.pop({
                    type: 'error',
                    title: 'Erro ao ler arquivo',
                    body: 'Não foi possível converter o arquivo para envio.',
                });
            })
            .finally(() => {
                this.busy = false;
            });
    }

    public close() {
        this.$uibModalInstance.dismiss('cancelar');
    }

    public formatBytes(bytes: number, decimals: number = 2) {
        return formatBytes(bytes, decimals);
    }

    public getLimitDate() {
        return getLimitDate(moment, this.$rootScope.configuracoes.DATA_FECHAMENTO_FOLHA);
    }

    public setSelects() {
        return montarSelectCompetencias(moment, this.$rootScope.configuracoes.DATA_FECHAMENTO_FOLHA);
    }

    public setMonths(year: number) {
        return montarMeses(moment, this.$rootScope.configuracoes.DATA_FECHAMENTO_FOLHA, year);
    }

    public setSelectMonths(year?: number | null) {
        this.entity.competenciames = null;
        this.selectCompetencias.meses = year ? this.setMonths(year) : [];
    }

    public validateNomeField() {
        if (!this.form?.nome?.$setValidity) {
            return;
        }

        const nome = this.normalizeNome();
        this.form.nome.$setValidity('trimmedRequired', !!nome);
        this.form.nome.$setValidity('maxLength', nome.length <= this.nomeMaxLength);
    }

    private normalizeNome() {
        return (this.entity.nome || '').trim();
    }

    private normalizeInteger(value: number | null) {
        if (value === null || value === undefined || value === ('' as any)) {
            return null;
        }

        return Number(value);
    }

    private validateSelectedFile() {
        const file = this.entity.file?.[0];
        const resultado = validarArquivo(file);

        if (resultado.valido) {
            return true;
        }

        // "ausente" não é erro a reportar: é só o estado inicial do formulário.
        if (resultado.erro && resultado.erro.tipo !== 'ausente') {
            this.clearSelectedFile();
            this.NewToaster.pop({
                type: resultado.erro.toasterType,
                title: resultado.erro.title,
                body: resultado.erro.body,
            });
        }

        return false;
    }

    private clearSelectedFile() {
        this.entity.file = null;
        this.isFileValid = false;
        limparInputArquivo('fileInput');
    }

    private fileToBase64(file: File) {
        return fileToBase64(file);
    }
}
